
export const LOCATIONS_LIST = 'LOCATIONS_LIST';
export const LOCATIONS_PAGINATION = 'LOCATIONS_PAGINATION';
 